import classnames from "classnames";
import { MessageDirection } from "@edgetier/watchtower-types";

/**
 * Determine the class name that should be applied based on the direction of the message.
 * @param direction     Whether the message is inbound or outbound.
 * @param baseClassName The base class that will always be applied.
 * @returns ${baseClassName}--in for inbound messages. ${baseClassName}--out for outbound messages.
 */
export const determineClassName = (direction: MessageDirection, baseClassName: string) => {
    return classnames(baseClassName, {
        [`${baseClassName}--in`]: direction === MessageDirection.Inbound,
        [`${baseClassName}--out`]: direction === MessageDirection.Outbound,
    });
};
